'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const fonts = require('../../style/fonts.js');
const textInput_types = require('./textInput.types.js');

var retrieveColorTheme = function retrieveColorTheme(style, prop) {
  return textInput_types.TextInputColors[style][prop];
};
var styledIcons = styled__default.div.withConfig({
  displayName: "textInputstyle__styledIcons",
  componentId: "sc-q34wel-0"
})(["position:absolute;width:15px;height:15px;z-index:1;&.left{left:8px;}"]);
var styledButtonIcons = styled__default.button.withConfig({
  displayName: "textInputstyle__styledButtonIcons",
  componentId: "sc-q34wel-1"
})(["position:absolute;border:0;background-color:", ";cursor:pointer;&.right{right:8px;}"], function (_ref) {
  var theme = _ref.theme;
  return retrieveColorTheme(theme, 'base');
});
var styledTextInput = styled__default.div.withConfig({
  displayName: "textInputstyle__styledTextInput",
  componentId: "sc-q34wel-2"
})(["display:flex;height:100%;position:relative;align-items:center;input{position:relative;font-size:15px;line-height:32px;color:", ";font-weight:400;height:32px;padding:0 8px;width:100%;background-color:", ";border-radius:", ";border:1px solid ", ";font-family:", ";::-ms-clear{display:none;}::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{display:none;}::placeholder{color:", ";}&.right{padding-right:32px;}&.left{padding-left:32px;}&[type='search']{height:32px;-webkit-appearance:none;}&:focus{outline:none;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return retrieveColorTheme(theme, 'icon');
}, function (_ref3) {
  var theme = _ref3.theme;
  return retrieveColorTheme(theme, 'base');
}, function (_ref4) {
  var $shape = _ref4.$shape;
  return $shape === textInput_types.TextInputShapes.PILL ? textInput_types.BorderRadius.FULL : textInput_types.BorderRadius.DEFAULT;
}, function (_ref5) {
  var theme = _ref5.theme;
  return retrieveColorTheme(theme, 'border');
}, fonts.primaryFont, function (_ref6) {
  var theme = _ref6.theme;
  return retrieveColorTheme(theme, 'text');
});

exports.styledButtonIcons = styledButtonIcons;
exports.styledIcons = styledIcons;
exports.styledTextInput = styledTextInput;
